module.exports = __webpack_public_path__ + "img/a7cfcb0.svg";